let PriceComponent = {
  templateUrl: './client/components/priceComponent.html',
  bindings: {
    sku: '<',
    citizenship: '<',
    secondCitizenship: '<',
    polesCard: '<',
    polesCardExpiryDate: '<',
    tuition: '<',
    installments: '<',
    discountCode: '<',
    companyNip: '<',
    nextProduct: '<',
    tebGraduate: '<',
    wsbGraduateSchool: '<',
    inSummary: '<'
  },
  controller: function ($scope, $sce, $http, UtilsService) {
    var ctrl = this;

    ctrl.isLoading = false;

    ctrl.pricing = {
        installments: null,
        installmentWithoutDiscount: null,
        entryFeeWithoutDiscount: null,
        entryFee: null,
        enrollmentFee: null,
        qualificationFee: null,
        omnibusPrice: null,
        offerNotAccepted: false,
        discounts: [],
    };

    ctrl.trans = (key) => Translator.trans(key);
    ctrl.transRaw = (key) => $sce.trustAsHtml(Translator.trans(key));

    ctrl.getAmount = function (fee, currency) {
        if (UtilsService.language === 'en') {
            return currency + ' ' + fee;
        }

        return fee + ' ' + currency;
    };

    ctrl.getPrice = function () {
      ctrl.isLoading = true;
      $http({
        method: 'GET',
        url: UtilsService.getApiPath('api/payment/' + ctrl.sku + '/get-price'),
        params: {
          'citizenship': typeof this.citizenship !== 'undefined' ? this.citizenship : null,
          'secondCitizenship': typeof this.secondCitizenship !== 'undefined' ? this.secondCitizenship : null,
          'polesCard': typeof this.polesCard !== 'undefined' ? this.polesCard : null,
          'polesCardExpiryDate': typeof this.polesCardExpiryDate !== 'undefined' ? this.polesCardExpiryDate : null,
          'tuition': typeof this.tuition !== 'undefined' ? this.tuition : null,
          'installments': typeof this.installments !== 'undefined' ? this.installments : null,
          'discountCode': typeof this.discountCode !== 'undefined' ? this.discountCode : null,
          'companyNip': typeof this.companyNip !== 'undefined' ? this.companyNip : null,
          'nextProduct': typeof this.nextProduct !== 'undefined' ? this.nextProduct : null,
          'tebGraduate': typeof this.tebGraduate !== 'undefined' ? this.tebGraduate : null,
          'wsbGraduateSchool': typeof this.wsbGraduateSchool !== 'undefined' ? this.wsbGraduateSchool : null
        }
      }).then(
        function success(response) {
          ctrl.isLoading = false;
          if (typeof response.data.price_first_installment !== 'undefined') {
            response.data.entry_fee = response.data.entry_fee || 0;
            ctrl.pricing.entry_fee = response.data.entry_fee + ' ' + response.data.entry_fee_currency;
            ctrl.pricing.discounts = response.data.discount_trade_names;
            ctrl.pricing.omnibusPrice = `${response.data.omnibus_price} ${response.data.price_first_installment_currency}`;
            ctrl.pricing.offerNotAccepted = response.data.offer_not_accepted && response.data.entry_fee === 0;
            ctrl.pricing.installment = response.data.price_first_installment + ' ' + response.data.price_first_installment_currency;

            if (response.data.price_first_installment < response.data.price_first_installment_without_discount) {
              ctrl.pricing.installmentWithoutDiscount = ctrl.getAmount(response.data.price_first_installment_without_discount, response.data.price_first_installment_currency);
            }

            if (response.data.entry_fee < response.data.entry_fee_without_discount) {
              ctrl.pricing.entryFeeWithoutDiscount = ctrl.getAmount(response.data.entry_fee_without_discount, response.data.entry_fee_currency);
            }

            if (response.data.enrollment_fee) {
              ctrl.pricing.enrollmentFee = ctrl.getAmount(response.data.enrollment_fee,  response.data.enrollment_fee_currency);
            }

            if (response.data.qualification_fee) {
              ctrl.pricing.qualificationFee = ctrl.getAmount(response.data.qualification_fee, response.data.qualification_fee_currency);
            }
          }
        },
        function error() {
            ctrl.isLoading = false;
            ctrl.pricing.installment = null;
            ctrl.pricing.installmentWithoutDiscount = null;
            ctrl.pricing.entryFee = null;
            ctrl.pricing.entryFeeWithoutDiscount = null;
            ctrl.pricing.enrollmentFee = null;
            ctrl.pricing.qualificationFee = null;
            ctrl.pricing.discounts = [];
            ctrl.pricing.omnibusPrice = null;
            ctrl.pricing.offerNotAccepted = false;
        }
      );
    };

    this.$onChanges = function () {
      this.getPrice();
    };

    ctrl.showInfo = () => window.product && (window.product.isFirstLevel);
  }
};

PriceComponent.$inject = ['$scope', '$sce', '$http', 'UtilsService'];
export default PriceComponent;
